module.exports = __webpack_public_path__ + "img/public/AdminIcons/securityDeposit.svg?9ef4bc2f";